<template>
  <v-sheet class="d-flex align-center">
    <v-sheet>
      {{ team_user.full_name }}
    </v-sheet>
    <v-chip class="ml-3" label outlined>
      {{ team_user.email }}
    </v-chip>
    <v-spacer></v-spacer>
    <v-chip
      :color="team_user.team_admin ? 'primary' : ''"
      @click="toggleAdminStatus()"
      :loading="toggling"
    >
      <span v-if="!toggling">
        {{ team_user.team_admin ? 'Admin' : 'User' }}
      </span>
      <span v-else>
        <v-progress-circular color="white" size="15" indeterminate></v-progress-circular>
      </span>
    </v-chip>
    <v-btn
      @click="removing = true"
      class="ml-4"
      v-tooltip="'Poista käyttäjä joukkueesta (vain Aku)'"
      small fab text>
      <v-icon color="red">mdi-delete-outline</v-icon>
    </v-btn>
    <confirmation-dialog
      :show="removing"
      @decline="removing = false"
      @accept="removeFromTeam"
      text="Poista joukkueesta?"
      btnColor="red"
      btnText="Poista"
    />
  </v-sheet>
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmationDialog from '../../../ConfirmationDialog.vue';

export default {
  props: ['team_user', 'team_id'],
  components: { ConfirmationDialog },
  data: () => ({
    toggling: false,
    removing: false
  }),
  methods: {
    ...mapActions('noti', [
      'success',
      'error'
    ]),
    ...mapActions('admin', [
      'updateUserTeam'
    ]),
    ...mapActions('team', [
      'removeUserFromTeam'
    ]),
    removeFromTeam() {
      this.removeUserFromTeam({
        email: this.team_user.email,
        team_id: this.team_id
      })
    },
    toggleAdminStatus() {
      this.toggling = true
      this.updateUserTeam({
        user_team: {
          team_admin: !this.team_user.team_admin,
        },
        email: this.team_user.email,
        team_id: this.team_id
      })
      .then(() => {
        this.success('admin status updated')
      })
      .catch(e => {
        this.error(e)
      })
      .finally(() => {
        this.toggling = false
      })
    }
  }
}
</script>